document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.shopify-section');

  function onScroll() {
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const visibility = Math.min(
        Math.max((windowHeight - rect.top) / windowHeight, 0),
        1
      );

      const scale = 0.75 + (0.25 * visibility);
      const opacity = 0.4 + (0.6 * visibility);

      section.style.transform = `scale(${scale})`;
      section.style.opacity = opacity;
    });
  }

  sections.forEach(section => {
    section.style.transition = 'transform 0.5s ease-out, opacity 0.5s ease-out';
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
});